"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_1 = __importStar(require("react"));
var HeaderTooltip_1 = __importDefault(require("containers/TableMaker/components/HeaderTooltip"));
var SortableArrows_1 = __importDefault(require("./SortableArrows"));
var SortButton_1 = __importDefault(require("./SortButton"));
var SortContext_1 = __importDefault(require("./SortContext"));
var utils_1 = require("./utils");
var MultiSortableHeader = function (_a) {
    var sortings = _a.sortings, _b = _a.defaultOrder, defaultOrder = _b === void 0 ? 1 : _b, _c = _a.glueString, glueString = _c === void 0 ? '&' : _c;
    var _d = (0, react_1.useContext)(SortContext_1.default), setSort = _d.setSort, sort = _d.sort;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "multiHeadsersWrapper" }, { children: [sortings.map(function (_a, idx, arr) {
                var sortKey = _a.sortKey, text = _a.text, headerTooltip = _a.headerTooltip;
                return [
                    (0, jsx_runtime_1.jsx)(SortButton_1.default, __assign({ onClick: (0, utils_1.makeToggleSort)(setSort, sortKey, defaultOrder, sort), isSelected: sort && sort.key === sortKey, hasSortKey: !!sortKey }, { children: headerTooltip
                            ? (0, jsx_runtime_1.jsx)(HeaderTooltip_1.default, __assign({ title: text, description: headerTooltip === null || headerTooltip === void 0 ? void 0 : headerTooltip.description, list: headerTooltip === null || headerTooltip === void 0 ? void 0 : headerTooltip.list }, { children: text }))
                            : text }), sortKey),
                    idx !== arr.length - 1 && (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [" ", glueString, " "] }, "".concat(sortKey, "-separator")),
                ].filter(end2end_1.notFalsy);
            }), (0, jsx_runtime_1.jsx)(SortableArrows_1.default, { sortOrder: sort && sortings.find(function (_a) {
                    var sortKey = _a.sortKey;
                    return sortKey === sort.key;
                }) ? sort.order : undefined })] })));
};
exports.default = MultiSortableHeader;
